// The routes.
//
// OVERRIDDEN FROM THE SCAFFOLD. The bottom-tabs shell the factory generated is replaced by a
// flat router, because this app has one screen and that screen wants the whole window: the
// canvas is the product, and the finish sheet lives where a tab bar would have been.
//
// Keeping the shell and hiding its tab bar would have been the smaller diff and the worse
// answer -- an IonTabs outlet with nothing in the bar is a wrapper that exists to be
// invisible. If a second destination arrives, this becomes a stack.

import { createRouter, createMemoryHistory } from '@ionic/vue-router';
import { PRODUCT_ROUTES, HOME_ROUTE } from './product-routes.js';

/** Where the app opens. main.js pushes this. */
export const HOME = HOME_ROUTE;

/** No tab bar. Kept exported because the shell's other files import it. */
export const TABS = [];

export default createRouter({
  history: createMemoryHistory(),
  routes: [
    { path: '/', redirect: HOME },
    ...PRODUCT_ROUTES.map((r) => ({
      path: r.path,
      name: r.id,
      component: r.component,
      props: true,
    })),
  ],
});
